<template>
  <button type="button" @click.stop="handleOpen" class="tooltip" :title="title">
    <div>?</div>
    <transition name="fade">
      <div class="tooltip__message" v-if="show">
        <div class="tooltip__message__text">
          <slot>{{ title }}</slot>
        </div>
        <button type="button" @click.stop="handleClose" class="tooltip__close">
          Close
        </button>
      </div>
    </transition>
  </button>
</template>

<script>
export default {
  name: "Tooltip",
  data() {
    return {
      show: false
    }
  },
  props: ["title"],
  methods: {
    handleOpen(e) {
      e.stopPropagation()
      this.$ga.event({
        eventCategory: "tooltip",
        eventAction: "open"
      })
      this.show = true
    },
    handleClose(e) {
      this.$ga.event({
        eventCategory: "tooltip",
        eventAction: "close"
      })
      this.show = false
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "../style/variables.scss";

.tooltip {
  align-self: center;
  position: relative;
  border: none;
  background-color: $color-white;
  color: $color-dark;
  box-shadow: 1px 1px 1px 0px rgba(0, 0, 0, 0.25);
  margin-left: auto;

  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  font-weight: bold;
  min-width: 1em;
  min-height: 1em;
  max-width: 1em;
  max-height: 1em;
  border-radius: 50%;
  border: 1px solid black;
  padding: 12px;
}

.tooltip:active {
  background-color: $color-dark;
}

.tooltip:active > :first-child {
  color: $color-white;
}

.tooltip > :first-child {
  position: absolute;
}

.tooltip__message {
  position: absolute;
  background-color: $color-dark;
  color: $color-white;
  top: 0;
  right: 0;
  border: 1px solid black;

  width: 250px;
  box-shadow: 3px 3px 3px 3px rgba(0, 0, 0, 0.25);
  border-radius: 5px;
  z-index: 2;
  transition: all;
}

.tooltip__message__text {
  text-align: left;
  font-size: 0.8em;
  font-weight: normal;
  padding: 10px;
}

.tooltip__close {
  color: $color-white;
  background: none;
  border: none;
  box-shadow: none;
  width: 100%;
  height: 30px;
  font-size: 0.7em;
  font-weight: bolder;
  text-transform: uppercase;
  margin-top: 10px;
}

.tooltip__close:active {
  font-weight: bold;
}

.fade-enter-active,
.fade-leave-active {
  transition: all 0.3s;
}

.fade-enter,
.fade-leave-to {
  transform: translateY(0%);
  opacity: 0;
}

@media (max-width: 767px) {
  .tooltip {
    min-width: 2.5em;
    min-height: 2.5em;
    max-width: 2.5em;
    max-height: 2.5em;
  }

  .tooltip > * {
  }
}
</style>
